export const LAST_SHOWN_KEY = 'last-product-sales-pop';
